// React & Libraries
import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

// Ant Design
import {
  Drawer
} from 'antd';

// Constants & Helpers
import Helpers from '@Apis/helpers';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import documentUINamesConstant from '@Apis/documentUINamesConstant';

// Common Components
import SendWhatsapp from '@Components/Common/ViewPurchaseOrder/SendWhatsapp';
import AddressSelector from '@Components/Common/FormUtils/AddressSelecter';
import ViewLoadingSkull from '@Components/Common/ViewLoadingSkull';
import ViewDocRightSection from '@Components/Common/ViewDocRightSection';
import PRZDrawer from '@Components/Common/UI/PRZDrawer';

// Actions
import SoActions from '@Actions/sales/soActions';
import AttachmentActions from '@Actions/attachmentActions';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import AnalyticsActions from '@Actions/application/analyticsActions';
import ActivityLogActions from '@Actions/activityLogActions';

// Other Components
import ConvertToMo from '@Components/Sales/SalesOrder/ViewSalesOrder/ConvertToMo';
import 'react-quill/dist/quill.bubble.css';
import CreatePurchaseRequestFromMo from '../../../Production/ManufacturingOrders/ViewManufacturingOrder/Drawer/CreatePurchaseRequestFromMo';
import DeliveryChallanForm from '../../../Inventory/DeliveryChallan/DeliveryChallanForm';
import PackingSlipForm from '../../PackingSlip/PackingSlipForm';
import SalesForm from '../SalesForm';
import ConsumptionForm from '@Components/Sales/Consumption/ConsumptionForm';

// Local components
import ChangeLocation from './UnFulfilledLines/ChangeLocation';
import FulfillForm from './UnFulfilledLines/FulfillForm';
import ReturnForm from './FulfilledLines/ReturnForm';
import InvoiceForm from '../../Invoice/InvoiceForm';
import RefundForm from './ReturnFulfilledLines/RefundForm';
import ShopifyADHOCForm from './ShopifyADHOCForm';
import './style.scss';
import ReservationSO from './ReservationSO';
import UpdateReservation from './UpdateReservation';
import ViewSOLeftSectionHeader from './ViewSOLeftSectionHeader';
import { handleFileChangeHelper, handleDrawerStateHelper, INITIAL_STATE, tenantIdProductMapping, renderFreightHelper, HideAdhocApprovalsHelper, renderChargesHelper, menuHelper, getLinkedDocumentInfoHelper } from './helper';
import ViewSOLeftSectionDetails from './ViewSOLeftSectionDetails';
import ViewSOLeftSectionAddresses from './ViewSOLeftSectionAddresses';
import ViewSOLeftSectionTables from './ViewSOLeftSectionTables';
import ViewSOFooter from './ViewSOFooter';

function ViewSalesOrder(props) {

  const {
    getSOByIdSuccess, user, getSOById, match, isQuickView, selectedSoId, selectedTenantId, selectedSO, selectedAttachment, getAttachmentByIdLoading, updateAttachmentLoading, MONEY, updateSOStatusLoading, updateSOWorkflowStepLoading, updateSOWorkflowStep, getSOByIdLoading, syncShopifySO, getReturns, quickUpdateSO, priceMasking,
  } = props;

  const [state, setState] = useState(INITIAL_STATE);

  const {
    isUserReady, isUserReadyForPrefillData, isGetAttachment, showNewInvoiceForm, showNewPackingSlipForm, isShowDrawerForChangeLocation, selectedReturn, updatedGstNumber, soMapping, fulfillmentId, isShowDrawerForReturn, selectedAddressType, showAddressDrawer, isShowDrawerForRefund, currentTenantId, currentOrderId, showWhatsappDrawer, shopifyLocationId, isShowDrawerForCreateFulfillment, selectedFulfillment, productSkuTenantIdMapping, tenantId, addShopifyADHOC, showConvertToMo, selectedTags, showConvertToPr, showDCDrawer, showReservationDrawer, showUpdateReservationDrawer, selectedOrderLine, showNewSalesForm, salesOrderType, documentUINames, showConsumptionDrawer, isEstimate
  } = state;

  const updateState = (newState) => {
    setState((oldState) => ({
      ...oldState,
      ...newState,
    }));
  };

  useEffect(() => {

    updateState({
      isEstimate: window.location.href.includes('/estimate') ? true : false,
      salesOrderType: window.location.href.includes('/estimate') ? 'SALES_ESTIMATE' : 'SALES_ORDER',
      documentUINames: {
        uiName: (window.location.href.includes('/estimate')) ? 'Estimate' : (window.location.href.includes('/amc-sales-order') ? 'AMC Sales Order' : 'Sales Order'),
        shortUIName: (window.location.href.includes('/estimate')) ? 'Estimate' : (window.location.href.includes('/amc-sales-order') ? 'AMC SO' : 'SO'),
        salesOrderUIName: 'Sales Order',
        salesOrderShortUIName: 'SO',
        estimateUIName: 'Estimate',
        estimateShortUIName: 'Estimate',
        amcSalesOrderUIName: 'AMC Sales Order',
        amcSalesOrderShortUIName: 'AMC SO',
      },
    });

    return () => {
      getSOByIdSuccess(null);
    };
  }, []);

  useEffect(() => {

    const { orderId } = match.params;

    if (user?.tenant_info?.tenant_id && !isUserReady) {
      const payload = {
        orgId: user?.tenant_info?.org_id,
        tenantId: isQuickView ? selectedTenantId : (Helpers.getTenantEntityPermission(user?.user_tenants, (window.location.href.includes('/estimate')) ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ).join(',') || user?.tenant_info?.tenant_id),
        soId: isQuickView ? selectedSoId : orderId,
        orderType: window.location.href.includes('/estimate') ? 'SALES_ESTIMATE' : 'SALES_ORDER',
        isReducerNeedToBeEmpty: true,
      }
      getSOById(payload);

      updateState({
        isUserReady: true,
        currentOrderId: isQuickView ? selectedSoId : orderId,
        currentTenantId: isQuickView ? selectedTenantId : (Helpers.getTenantEntityPermission(user?.user_tenants, (window.location.href.includes('/estimate')) ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ).join(',') || user?.tenant_info?.tenant_id),
      });
    }

    if (selectedSO && !isUserReadyForPrefillData) {
      const lineCf = selectedSO?.sales_order_lines?.[0]?.so_line_custom_fields;
      const soLines = selectedSO.sales_order_lines;
      const soMapping = {};
      for (let i = 0; i < soLines?.length; i++) {
        if (soMapping.hasOwnProperty(soLines[i]?.product_sku_info?.product_sku_id)) {
          soMapping[soLines[i]?.product_sku_info?.product_sku_id].push({
            ...soLines[i],
          });
        } else {
          soMapping[soLines[i]?.product_sku_info?.product_sku_id] = [{
            ...soLines[i],
          }];
        }
      }
      updateState({
        fileList: selectedSO?.attachments,
        isUserReadyForPrefillData: true,
        updatedGstNumber: selectedSO?.customer_info?.gst_number,
        updateAccountManager: selectedSO?.account_manager_id,
        updatedPaymentTerms: Number(selectedSO?.payment_terms?.[0]?.due_days || 0),
        updatePaymentRemark: selectedSO?.payment_terms?.[0]?.remark,
        updateDeliveryDate: selectedSO.delivery_date ? dayjs(selectedSO.delivery_date) : '',
        updateEstimateExpiryDate: selectedSO.estimate_expiry_date ? dayjs(selectedSO.estimate_expiry_date) : '',
        soMapping,
        selectedTags: selectedSO?.tags?.length > 0 ? selectedSO?.tags : [],
        cfSalesOrderLine: lineCf,
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(lineCf, state.visibleColumns),
      });
    }

    if (selectedAttachment && isGetAttachment && !getAttachmentByIdLoading && !updateAttachmentLoading) {
      updateState({
        fileList: props?.selectedAttachment,
        isGetAttachment: false,
      });
    }

    if (props?.isEstimate) {
      updateState({
        isEstimate: props?.isEstimate,
      });
    }

    if (user?.tenant_info) {
      const tempDocumentUINames = documentUINamesConstant(user);
      updateState({
        documentUINames: {
          uiName: (window.location.href.includes('/estimate')) ? tempDocumentUINames.estimateUIName : ((window.location.href.includes('/amc-sales-order')) ? tempDocumentUINames.amcSalesOrderUIName : tempDocumentUINames.salesOrderUIName),

          shortUIName: (window.location.href.includes('/estimate')) ? tempDocumentUINames.estimateShortUIName : ((window.location.href.includes('/amc-sales-order')) ? tempDocumentUINames.amcSalesOrderShortUIName : tempDocumentUINames.salesOrderShortUIName),

          salesOrderUIName: tempDocumentUINames.salesOrderUIName,

          salesOrderShortUIName: tempDocumentUINames.salesOrderShortUIName,

          estimateUIName: tempDocumentUINames.estimateUIName,

          estimateShortUIName: tempDocumentUINames.estimateShortUIName,

          amcSalesOrderUIName: tempDocumentUINames.amcSalesOrderUIName,

          amcSalesOrderShortUIName: tempDocumentUINames.amcSalesOrderShortUIName,
        },
      });
    }
  }, [user, selectedSO, selectedAttachment, getAttachmentByIdLoading, updateAttachmentLoading, props?.isEstimate]);

  const getLinkedDocumentInfo = () => (
    getLinkedDocumentInfoHelper({ props, state, updateState })
  );

  const quantityPrecision = user?.tenant_info?.inventory_config?.settings?.quantity_precision;

  const fixedMenuBar = user?.side_menu_bar_type === 'FIXED';

  const quickUpdateDisable = !(selectedSO?.status === 'VOID') && !selectedSO?.shopify_order_id && !selectedSO?.unicommerce_invoice_code;

  const hasSoEditAccess = Helpers.getPermission(isEstimate ? Helpers.permissionEntities.SALES_ESTIMATE : Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.UPDATE, user);

  const accountingGSTTransactionAsPerMaster = user?.tenant_info?.sales_config?.sub_modules?.customer?.settings?.gst_details_in_transaction === 'AS_PER_MASTER';

  return (
    <Fragment>
      <Drawer
        open={showAddressDrawer}
        onClose={() => updateState({ showAddressDrawer: false, selectedAddressType: '' })}
        width="360"
        destroyOnClose
      >
        <AddressSelector
          title={selectedAddressType === 'TENANT_SHIPPING' ? 'Shipping Address' : 'Billing Address'}
          addressType={selectedAddressType?.split('_')[0]}
          selectedAddressId={
            selectedAddressType === 'TENANT_SHIPPING'
              ? selectedSO?.shipping_address_info?.address_id
              : selectedSO?.billing_address_info?.address_id
          }
          onAddressChange={(address) => {
            if (selectedAddressType === 'TENANT_SHIPPING') {
              quickUpdateSO({
                shipping_address_id: address?.address_id,
                order_id: selectedSO.order_id,
              }, () => {
                updateState({ showAddressDrawer: false });
                const payload = {
                  orgId: user?.tenant_info?.org_id,
                  tenantId: currentTenantId,
                  soId: currentOrderId,
                  orderType: salesOrderType,
                };
                getSOById(payload);
              });
            } else {
              quickUpdateSO({
                billing_address_id: address?.address_id,
                order_id: selectedSO.order_id,
              }, () => {
                updateState({ showAddressDrawer: false });
                const payload = {
                  orgId: user?.tenant_info?.org_id,
                  tenantId: currentTenantId,
                  soId: currentOrderId,
                  orderType: salesOrderType,
                };
                getSOById(payload);
              });
            }
          }}
          entityId={selectedSO?.customer_id}
          entityType="CUSTOMER"
          tenantId={selectedSO?.tenant_id}
        />
      </Drawer>
      <div className={`view-document__wrapper ${!isQuickView ? 'view-document__wrapper-page' : ''}`}>
        {(!getSOByIdLoading && !updateSOStatusLoading) || (!!showNewSalesForm)
          ? (
            <div className="ant-row">
              <div className={`${fixedMenuBar ? 'ant-col-md-16' : 'ant-col-md-17'} ant-col-xs-24`}>
                <div className={`view-left__wrapper ${!isQuickView ? 'is-page-view' : ''}`}>
                  <ViewSOLeftSectionHeader
                    props={props}
                    state={state}
                    updateState={updateState}
                  />
                  <ViewSOLeftSectionDetails
                    props={props}
                    state={state}
                    updateState={updateState}
                    quickUpdateDisable={quickUpdateDisable}
                    hasSoEditAccess={hasSoEditAccess}
                    accountingGSTTransactionAsPerMaster={accountingGSTTransactionAsPerMaster}
                  />
                  <ViewSOLeftSectionAddresses
                    props={props}
                    state={state}
                    updateState={updateState}
                    quickUpdateDisable={quickUpdateDisable}
                  />
                  <br />
                  <ViewSOLeftSectionTables
                    props={props}
                    state={state}
                    updateState={updateState}
                    quickUpdateDisable={quickUpdateDisable}
                    hasSoEditAccess={hasSoEditAccess}
                    quantityPrecision={quantityPrecision}
                  />
                  {/* Footer */}

                  <ViewSOFooter
                    props={props}
                    state={state}
                    updateState={updateState}
                  />
                </div>
              </div>

              <ViewDocRightSection
                entityType={isEstimate ? "SALES_ESTIMATE" : "SALES_ORDER"}
                entityId={Number(currentOrderId)}
                MONEY={MONEY}
                user={user}
                isQuickView={isQuickView}
                tagSelectorProps={{
                  isEnabled: true,
                  entityType: 'SALES_ORDER',
                  selectedTags: selectedTags,
                  isMultipleTagsAllowed: true,
                  tagSearchAllowed: true,
                  onChange: (value) => updateState({ selectedTags: value }),
                  placeholder: "Select Tags",
                }}
                workflowTimelineProps={{
                  isEnabled: selectedSO?.custom_status_info?.type !== 'DRAFT',
                  workflowSteps: selectedSO?.workflow_steps,
                  workflowStepId: selectedSO?.workflow_step_id,
                  loading: updateSOWorkflowStepLoading,
                  updateStep: updateSOWorkflowStep,
                  callback: () => {
                    const payload = {
                      orgId: user?.tenant_info?.org_id,
                      tenantId: currentTenantId,
                      soId: currentOrderId,
                      orderType: salesOrderType,
                    };
                    getSOById(payload);
                  },
                }}
                activityLogProps={{
                  isEnabled: selectedSO,
                  entityType: isEstimate ? "sales_estimate" : selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? "annual_maintenance_contract" : "sales_order",
                  entityName: documentUINames.uiName,
                }}
                linkedDocumentsInfo={getLinkedDocumentInfo()}
              />
            </div>
          )
          : (
            //  Loader
            <ViewLoadingSkull isQuickView={isQuickView} fixedMenuBar={fixedMenuBar} />
          )}

        <PRZDrawer
          onClose={() => updateState({ isShowDrawerForCreateFulfillment: false })}
          open={isShowDrawerForCreateFulfillment}
          width="75%"
          headerWidth={1140}
          title='Create Order Fulfilment'
          destroyOnClose
        >
          <FulfillForm
            selectedLocationFulfillment={selectedSO?.shopify_fulfillments?.unfulfilled_fulfillments?.filter((item) => item?.assigned_shopify_location_id === shopifyLocationId && item?.fulfillment_id === fulfillmentId)?.[0]}
            callback={() => {
              updateState({ isShowDrawerForCreateFulfillment: false });
              const payload = {
                orgId: user?.tenant_info?.org_id,
                tenantId: currentTenantId,
                soId: currentOrderId,
                orderType: salesOrderType,
              };
              getSOById(payload);
            }}
            soMapping={soMapping}
            selectedSO={selectedSO}
            orderId={selectedSO?.order_id}
          />
        </PRZDrawer>
        <PRZDrawer
          onClose={() => updateState({ showNewInvoiceForm: false })}
          open={showNewInvoiceForm}
          width={1250}
          headerWidth={1200}
          title='Create Invoice'
          destroyOnClose
        >
          <InvoiceForm
            selectedOrderForInvoice={{
              ...selectedSO,
              tags: selectedTags || [],
              customer_info: {
                ...((selectedSO && selectedSO.customer_info) || {}),
                gst_number: updatedGstNumber,
              },
            }}
            callback={() => {
              updateState({ showNewInvoiceForm: false });
              const payload = {
                orgId: user?.tenant_info?.org_id,
                tenantId: currentTenantId,
                soId: currentOrderId,
                orderType: salesOrderType,
              };
              getSOById(payload);
            }}
            isSalesEstimate={isEstimate}
            isCarryForward={true}
          />
        </PRZDrawer>
        <PRZDrawer
          onClose={() => updateState({ showNewPackingSlipForm: false })}
          open={showNewPackingSlipForm}
          width={1250}
          headerWidth={1200}
          title='Create Packing Slip'
          destroyOnClose
        >
          <PackingSlipForm
            selectedSOForPs={{
              ...selectedSO,
              tags: selectedTags || [],
              customer_info: {
                ...((selectedSO && selectedSO.customer_info) || {}),
                gst_number: updatedGstNumber,
              },
            }}
            callback={() => {
              updateState({ showNewPackingSlipForm: false });
              const payload = {
                orgId: user?.tenant_info?.org_id,
                tenantId: currentTenantId,
                soId: currentOrderId,
                orderType: salesOrderType,
              };
              getSOById(payload);
            }}
            isCarryForward={true}
          />

        </PRZDrawer>
        <PRZDrawer
          onClose={() => updateState({ showNewSalesForm: false })}
          open={showNewSalesForm}
          width={1250}
          headerWidth={1200}
          title={`Create ${documentUINames.salesOrderUIName}`}
        >
          <SalesForm
            callback={() => {
              updateState({ showNewSalesForm: false });
              const payload = {
                orgId: user?.tenant_info?.org_id,
                tenantId: currentTenantId,
                soId: currentOrderId,
                orderType: salesOrderType,
              };
              getSOById(payload);
            }}
            estimateTenantId={selectedSO?.tenant_id}
            isSalesEstimate={isEstimate}
            estimateId={currentOrderId}
            isCarryForward={true}
          />
        </PRZDrawer>
      </div>
      <PRZDrawer
        onClose={() => updateState({ isShowDrawerForChangeLocation: false })}
        open={isShowDrawerForChangeLocation}
        width={360}
        headerWidth={305}
        title='Change Location'
        destroyOnClose
      >
        <ChangeLocation
          callback={() => {
            updateState({ isShowDrawerForChangeLocation: false });
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
          }}
          shopifyLocationId={shopifyLocationId}
          fulfillmentId={fulfillmentId}
          productSkuTenantIdMapping={productSkuTenantIdMapping}
          tenantIdProductMapping={tenantIdProductMapping(productSkuTenantIdMapping, selectedSO?.sales_order_lines)}
          tenantId={tenantId}
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ isShowDrawerForReturn: false })}
        open={isShowDrawerForReturn}
        width={1000}
        headerWidth={940}
        title='Return Fulfillment'
        destroyOnClose
      >
        <ReturnForm
          selectedFulfillment={selectedFulfillment}
          selectedSO={selectedSO}
          callback={() => {
            updateState({ isShowDrawerForReturn: false });
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
          }}
          soMapping={soMapping}
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ isShowDrawerForRefund: false })}
        open={isShowDrawerForRefund}
        width={1000}
        headerWidth={940}
        title='Create Refund'
        destroyOnClose
      >
        <RefundForm
          selectedReturn={selectedReturn}
          selectedSO={selectedSO}
          callback={() => {
            updateState({ isShowDrawerForRefund: false });
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
            getReturns(selectedSO?.shopify_shop_name, selectedSO?.shopify_order_id, selectedSO?.order_id);
          }}
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ addShopifyADHOC: false })}
        open={addShopifyADHOC}
        width={340}
        headerWidth={290}
        title='Add new item to shopify order'
        destroyOnClose
      >
        <ShopifyADHOCForm
          selectedSO={selectedSO}
          callback={() => {
            updateState({ addShopifyADHOC: false });
            syncShopifySO(
              {
                shopify_order_id: selectedSO?.shopify_order_id,
                shop_name: selectedSO?.shopify_shop_name,
              },
              () => {
                const payload = {
                  orgId: user?.tenant_info?.org_id,
                  tenantId: currentTenantId,
                  soId: currentOrderId,
                  orderType: salesOrderType,
                };
                getSOById(payload);
              },
            );
          }}
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ showConvertToMo: false })}
        open={showConvertToMo}
        width={1080}
        headerWidth={1030}
        title='Create Manufacturing Orders'
        destroyOnClose
      >
        <ConvertToMo
          selectedSO={selectedSO}
          callback={() => {
            updateState({ showConvertToMo: false });
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
          }}
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ showDCDrawer: false })}
        open={showDCDrawer}
        width={1200}
        headerWidth={1150}
        title='Create Delivery Challan'
        destroyOnClose
      >
        <DeliveryChallanForm
          selectedInvoice={{
            ...selectedSO,
            tags: selectedTags || [],
            customer_info: {
              ...((selectedSO && selectedSO.customer_info) || {}),
              gst_number: updatedGstNumber,
            },
          }}
          callback={() => {
            updateState({ showDCDrawer: false });
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
          }}
          documentType="Invoice"
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ showConsumptionDrawer: false })}
        open={showConsumptionDrawer}
        width={1250}
        headerWidth={955}
        title='Create Consumption Order'
        destroyOnClose
      >
        <ConsumptionForm
          selectedAMCForConsumption={selectedSO}
          callback={() => {
            updateState({ showConsumptionDrawer: false });
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
          }}
          isQuickView
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ showConvertToPr: false })}
        open={showConvertToPr}
        width={1150}
        headerWidth={1100}
        title='Create New Material Request'
        destroyOnClose
      >
        <CreatePurchaseRequestFromMo
          selectedSO={selectedSO}
          callback={() => {
            updateState({ showConvertToPr: false });
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
          }}
        />
      </PRZDrawer>
      <PRZDrawer
        open={showWhatsappDrawer}
        width={360}
        headerWidth={310}
        title='Share on Whatsapp'
        mask
        onClose={() => updateState({ showWhatsappDrawer: false })}
        destroyOnClose
      >
        <SendWhatsapp selectedEntity={selectedSO} entityName="sales_order" callback={() => updateState({ showWhatsappDrawer: false })} />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => {
          updateState({ showUpdateReservationDrawer: false });
        }}
        open={showUpdateReservationDrawer}
        width={970}
        headerWidth={920}
        title='Update Reservation Stock'
        destroyOnClose
      >
        <UpdateReservation
          order={selectedOrderLine}
          callback={() => {
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
          }}
          mrpId={selectedSO?.mrp_id}
          entityId={selectedOrderLine?.order_id}
          entityType="SALES_ORDER"
          entityLineId={selectedOrderLine?.order_line_id}
          entityLineType="SALES_ORDER_LINE"
          productName={selectedOrderLine?.product_sku_info?.product_sku_name}
          productSkuId={selectedOrderLine?.product_sku_info?.internal_sku_code}
          productInternalSkuCode={selectedOrderLine?.product_sku_info?.internal_sku_code}
        />
      </PRZDrawer>
      <PRZDrawer
        onClose={() => updateState({ showReservationDrawer: false })}
        open={showReservationDrawer}
        width={970}
        headerWidth={920}
        title='Reservation Stock'
        destroyOnClose
      >
        <ReservationSO
          selectedSO={selectedSO}
          callback={() => {
            updateState({ showReservationDrawer: false });
            const payload = {
              orgId: user?.tenant_info?.org_id,
              tenantId: currentTenantId,
              soId: currentOrderId,
              orderType: salesOrderType,
            };
            getSOById(payload);
          }}
        />
      </PRZDrawer>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, SOReducers, AttachmentReducers, UnicommerceIntegrationReducers, ShopifyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getSOByIdLoading: SOReducers.getSOByIdLoading,
  selectedSO: SOReducers.selectedSO,
  updateSOStatusLoading: SOReducers.updateSOStatusLoading,
  updateSOWorkflowStepLoading: SOReducers.updateSOWorkflowStepLoading,
  deleteSOLoading: SOReducers.deleteSOLoading,
  selectedAttachment: AttachmentReducers.selectedAttachment,
  getAttachmentByIdLoading: AttachmentReducers.getAttachmentByIdLoading,
  updateAttachmentLoading: AttachmentReducers.updateAttachmentLoading,
  syncSOLoading: UnicommerceIntegrationReducers.syncSOLoading,
  syncShopifySOLoading: ShopifyIntegrationReducers.syncShopifySOLoading,
  cancelShopifyOrderLoading: ShopifyIntegrationReducers.cancelShopifyOrderLoading,
  unLinkMOFromSOLoading: SOReducers.unLinkMOFromSOLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  updateSOStatus: (payload, callback) => dispatch(SoActions.updateSOStatus(payload, callback)),
  updateSOWorkflowStep: (payload, callback) => dispatch(SoActions.updateSOWorkflowStep(payload, callback)),
  getSOById: (payload, callback) => dispatch(SoActions.getSOById(payload, callback)),
  getSOByIdSuccess: (selectedSO) => dispatch(SoActions.getSOByIdSuccess(selectedSO)),
  deleteSO: (payload, callback) => dispatch(SoActions.deleteSO(payload, callback)),
  getAttachmentById: (entityId, entityName, callback) => dispatch(
    AttachmentActions.getAttachmentById(entityId, entityName, callback),
  ),
  updateAttachment: (payload, callback) => dispatch(
    AttachmentActions.updateAttachment(payload, callback),
  ),
  syncSO: (payload, callback) => dispatch(
    UnicommerceIntegrationActions.syncSO(payload, callback),
  ),
  syncShopifySO: (payload, callback) => dispatch(ShopifyIntegrationActions.syncShopifySO(payload, callback)),
  cancelShopifyOrder: (payload, callback) => dispatch(ShopifyIntegrationActions.cancelShopifyOrder(payload, callback)),
  getReturns: (shopName, shopifyOrderId, orderId) => dispatch(SoActions.getReturns(shopName, shopifyOrderId, orderId)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  unLinkMOFromSo: (payload, callback) => dispatch(SoActions.unLinkMOFromSo(payload, callback)),
  quickUpdateSO: (payload, callback, rollback) => dispatch(SoActions.quickUpdateSO(payload, callback, rollback)),
  getActivityLog: (entityId, entityName, page, limit, callback) => dispatch(ActivityLogActions.getActivityLog(entityId, entityName, page, limit, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewSalesOrder));
